export default __webpack_public_path__ + "static/media/Ytd_Template.b5c5818f.xlsx";